/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import type ImpersonateService from 'walden-fast/services/impersonate';
import type { ImpersonationAccount } from 'walden-fast/types/fast-backend/account';

export interface ImpersonatorDropdownSignature {
  Args: {
    availableAccounts: ImpersonationAccount[];
  };
}

export default class ImpersonatorDropdownComponent extends Component<ImpersonatorDropdownSignature> {
  @service('impersonate') declare impersonateService: ImpersonateService;

  @tracked searchTerm = '';

  get filteredAccounts() {
    let accounts = this.args.availableAccounts;

    if (this.searchTerm.trim()) {
      const searchLower = this.searchTerm.toLowerCase();
      accounts = accounts.filter((account) =>
        account.displayName.toLowerCase().includes(searchLower),
      );
    }

    if (this.activeImpersonationAccount) {
      accounts = [...accounts].sort((a, b) => {
        if (a.id === this.activeImpersonationAccount?.id) return -1;
        if (b.id === this.activeImpersonationAccount?.id) return 1;
        return 0;
      });
    }

    return accounts;
  }

  get activeImpersonationAccount() {
    return this.impersonateService.impersonationAccount;
  }

  updateSearchTerm = (value: string) => {
    this.searchTerm = value;
  };

  setImpersonation = task(async (account: ImpersonationAccount) => {
    if (this.activeImpersonationAccount?.id !== account.id) {
      await this.impersonateService.activateImpersonation(account);
    }
  });

  @action
  clearImpersonation() {
    this.impersonateService.stopImpersonation();
  }
}
